import "@mdi/font/css/materialdesignicons.css";
import "vuetify/styles";

import { createVuetify } from "vuetify";

export default createVuetify({
  theme: {
    defaultTheme: "linkberatung",
    themes: {
      linkberatung: {
        dark: false,
        colors: {
          background: "#FFFFFF",
          surface: "#FFFFFF",
          primary: "#0B1F3B",
          secondary: "#6C4CF1",
          accent: "#6C4CF1",
          cta: "#F59E0B",
          ctaDark: "#D97706",
          cream: "#FBF7F0",
          ink: "#0B1F3B",
          inkSoft: "#3A4A66",
          mute: "#7B8AA1",
          line: "#E8E0D2",
          success: "#16A34A",
          warning: "#F59E0B",
          error: "#DC2626",
        },
      },
    },
  },
  defaults: {
    VBtn: {
      style: "text-transform: none; letter-spacing: 0;",
      rounded: "pill",
    },
    VCard: {
      rounded: "lg",
    },
  },
});
